export const COMMITTED_PURCHASE_DEAL = 'COMMITTED_PURCHASE_DEAL';
